import Storage from "@/helpers/storage";

export default class InitialMessagePop {
  static isDue(maxPops) {
    let duePop = false;
    let numPops = Storage.getItem("numberInitialMessagePops") || 0;
    const lastPopAt = Storage.getItem("lastInitialMessagePopAt") || null;
    const timeNow = Math.round(new Date().getTime() / 1000);
    const timeYesterday = timeNow - 24 * 3600;

    // -1 = always send pop
    if (maxPops === -1) {
      duePop = true;

      // disabled
    } else if (maxPops === 0) {
      duePop = false;

      // They haven't received an initial message pop in the last 24 hours
    } else if (!lastPopAt || lastPopAt < timeYesterday) {
      duePop = true;
      numPops = 0; // reset for the day

      // Haven't yet received the max number of initial pops for the day
    } else if (numPops < maxPops) {
      duePop = true;
    }

    // Update when last pop was received, and the count
    if (duePop) {
      Storage.setItem("lastInitialMessagePopAt", timeNow);
      Storage.setItem("numberInitialMessagePops", numPops + 1);
    }

    return duePop;
  }
}
